import React, { memo } from "react";

import { CELL } from "./CatalogFilters";
import { rowOpener } from "./DetailModal";
import { HISTORY_STATUS, HISTORY_TEXT, shortWhen } from "./catalogText";
import { labelOf } from "./useHistory";

const T = HISTORY_TEXT;
const TAG = "inline-block rounded-full px-2 py-0.5 text-xs font-semibold";
const ROW = "border-t border-[#EBECE6] cursor-pointer transition hover:bg-[#fafaf8] focus:outline-none focus-visible:bg-cyan-50";

/** One learning event: when, product · category, cause (with manual/auto and escalated badges), outcome and status (undone
 * with its reason). A click, Enter or Space opens its details, where Undo / Redo live. `options` carries the server's
 * kind/status/reason labels. Memoised: typing in a filter re-renders the view, not the rows of the page already shown. */
function HistoryRow({ item, options, onOpen }) {
  const statusKey = item.undone ? HISTORY_STATUS.UNDONE : HISTORY_STATUS.ACTIVE;
  return (
    <tr className={`${ROW} ${item.undone ? "text-gray-500" : "text-[#253439]"}`} aria-label={T.row.open(item.cause_label)}
      {...rowOpener(() => onOpen(item))}>
      <th scope="row" className={`${CELL} text-left font-medium whitespace-nowrap`}>{shortWhen(item.when)}</th>
      <td className={`${CELL} text-xs uppercase tracking-wide text-cyan-700`}>
        {[item.product, item.category_label || item.category].filter(Boolean).join(" · ")}
      </td>
      <td className={CELL}>
        <span className="break-words">{item.cause_label}</span>
        <span className="ml-2 inline-flex flex-wrap gap-1 align-middle">
          {item.manual
            ? <span className={`${TAG} border border-amber-300 bg-amber-50 text-amber-800`} title={T.badges.manualHint}>{T.badges.manual}</span>
            : <span className={`${TAG} bg-gray-100 text-gray-600`}>{T.badges.auto}</span>}
          {item.escalated && <span className={`${TAG} border border-orange-200 bg-orange-50 text-orange-700`}>{T.badges.escalated}</span>}
        </span>
      </td>
      <td className={CELL}>{labelOf(options.kinds, item.kind)}</td>
      <td className={CELL}>
        <span className={item.undone ? `${TAG} bg-gray-100 text-gray-600` : `${TAG} border border-cyan-200 bg-cyan-50 text-cyan-700`}>
          {labelOf(options.statuses, statusKey)}
        </span>
        {item.undone && item.reason && <span className="ml-2 text-xs text-gray-500">{labelOf(options.undo_reasons, item.reason)}</span>}
        {item.undone && item.undone_at && <span className="ml-2 text-xs text-gray-400">{T.row.undoneAt(shortWhen(item.undone_at))}</span>}
      </td>
    </tr>
  );
}

export default memo(HistoryRow);
